<template>
	<div>
		<div v-if="panel.html || panel.type == 'html'" v-html="html"></div>
		<div v-if="panel.type == 'multiselect'">
			<form>
				<fieldset>
					<div v-for="item in panel.multiselect" class="input-group">
						<input :id="item.id" v-model="multiselectInput" v-if="!panel.max" type="checkbox" :name="panel.name + '[]'"
							:value="item.value">
						<input :id="item.id" v-model="multiselectInput" v-else type="checkbox" :name="panel.name + '[]'"
							:value="item.value"
							:disabled="multiselectInput.length > panel.max - 1 && !multiselectInput.includes(item.value)">
						<label v-html="item.html" :for="item.id"></label>
					</div>
				</fieldset>
			</form>
		</div>
		<div v-else-if="panel.type == 'levels'">
			<form>
				<div v-for="group in panel.levels" class="input-group" v-if="variables.symptoms.includes(group.value)">
					<label>{{ group.name }}</label>
					<div v-for="item in group.radios" class="radio-group">
						<input :id="item.id" v-model="levels[group.value]" type="radio" :name="item.name" :value="item.value">
						<label v-html="item.html" :for="item.id"></label>
					</div>
				</div>
			</form>
		</div>
		<form v-else-if="panel.type == 'textbox'">
			<input :id="panel.name" v-model="textInput" type="text" :name="panel.name" :placeholder="panel.placeholder"
				required="true" @keydown.enter.prevent="nextStep">
		</form>
		<div v-else-if="panel.type == 'result'">
			<div v-if="panel.name == 'did-you-know'" v-html="didYouKnowHtml"></div>
			<div v-if="panel.name == 'patient-stories'" v-html="patientStoriesHtml"></div>
		</div>
		<form v-else-if="panel.type == 'form'" class="ajax-form">
			<input id="first_name" type="text" v-model="form.first_name" name="first_name" :placeholder="panel.first_name_placeholder" required>
			<input id="last_name" type="text" v-model="form.last_name" name="last_name" :placeholder="panel.last_name_placeholder" required>
			<input id="email" type="email" v-model="form.email" name="email" :placeholder="panel.email_placeholder" required="true">
			<input id="phone" type="tel" v-model="form.phone" name="phone" :placeholder="panel.phone_placeholder">
			<div class="checkbox">
				<!-- <input id="newsletter-signup" v-model="form.newsletterSignup" type="checkbox" :value="checkboxVal" :checked="booleanValue" v-on:input="checkboxVal=$event.target.value" name="newsletter-signup"> -->
				<input id="newsletter-signup" v-model="form.newsletterSignup" type="checkbox" name="newsletter-signup" :false-value="0">
				<label for="newsletter-signup">{{ panel.newsletterText }}</label>
			</div>
		</form>
		<div class="panel-button">
			<button class="next" @click.prevent="nextStep" :disabled="!canContinue">{{ panel.buttonText }}</button>
			<br v-if="panel.noneButtonText">
			<button v-if="panel.noneButtonText" @click.prevent="noneOfAbove"
				class="text none">{{ panel.noneButtonText }}</button>
		</div>
	</div>
</template>

<script>
import gtag from './gtag.js';
export default {
	mixins: [gtag],
	props: ['panel', 'variables'],

	data() {
		return {
			textInput: '',
			multiselectInput: [],
			levels: {},
			form: {
				first_name: '',
				last_name: '',
				email: '',
				phone: '', // Optional
				newsletterSignup: 1
			}
		}
	},

	mounted() {
		if(this.panel.name == 'symptoms') this.multiselectInput = this.variables.symptoms;
		if(this.panel.name == 'levels') this.levels = this.variables.levels;
		if(this.panel.name == 'goals') this.multiselectInput = this.variables.goals;
	},

	methods: {
		noneOfAbove() {
			this.multiselectInput = [];
			this.nextStep();
		},

		nextStep() {
			if (this.panel.type == 'html') {
				this.$emit('next-step');
			} else if (this.panel.type == 'multiselect') {
				this.$emit('set-variable', {key: this.panel.name, value: this.multiselectInput});
				if(this.multiselectInput.length === 0) {
					this.$emit('skip-step');
				} else {
					this.$emit('next-step');
				}
			} else if (this.panel.type == 'levels') {
				this.$emit('set-variable', {key: this.panel.name, value: this.levels});
				this.$emit('next-step');
			} else if (this.panel.type == 'textbox') {
				if (this.textInput === '') return;
				this.$emit('set-variable', {key: this.panel.name, value: this.textInput});
				this.$emit('next-step');
			} else if (this.panel.type == 'result') {
				this.$emit('next-step');
			} else if (this.panel.type == 'form') {
				this.$emit(
					'submit-form',
					{
						first_name: this.form.first_name,
						last_name: this.form.last_name,
						email: this.form.email,
						phone: this.form.phone,
						newsletterSignup: this.form.newsletterSignup
					}
				);
			}
		}
	},

	watch: {
		'variables.levels': function(newValue, oldValue) {
			if(Object.keys(newValue).length == 0 && Object.keys(oldValue).length > 0) this.levels = {};
		}
	},

	computed: {
		html() {
			if (!this.panel.html) return;
			var html = this.panel.html;
			Object.keys(this.variables).forEach(key => {
				html = html.replace(`((${key}))`, this.variables[key]);
			});
			return html;
		},

		canContinue() {
			if (this.panel.type == 'multiselect') {
				return this.multiselectInput.length > 0;
			} else if (this.panel.type == 'levels') {
				return Object.keys(this.levels).length == this.variables.symptoms.length
			} else if (this.panel.type == 'textbox') {
				return this.textInput !== '';
			} else if (this.panel.type == 'form') {
				return this.form.email.match(/[^@]+@[^@]+\.[^@]+/g) && this.form.first_name !== '' && this.form.last_name !== '';
			} else {
				return true;
			}
		},

		didYouKnowHtml() {
			if(this.panel.name != 'did-you-know') return;
			var symptoms = this.variables.symptoms.slice().sort().toString();
			var result = 'V1';
			if (symptoms == 'B' || symptoms == 'B,H') {
				result = 'V2';
			}
			if (this.variables.symptoms.length == 0 || symptoms == 'H') {
				result = 'V3';
			}
			this.variables.didYouKnowResult = result;
			return this.panel.matrix[result.toLowerCase()];
		},

		patientStoriesHtml() {
			if(this.panel.name != 'patient-stories') return;
			var goals = this.variables.goals.slice().sort().toString();
			var result = 'A';
			if (goals == 'd' || goals == 'e' || goals == 'd,e') {
				result = 'C';
			}
			if (goals == 'b' || goals == 'b,d' || goals == 'b,e' || goals == 'b,d,e') {
				result = 'B';
			}
			this.variables.patientStoriesResult = result;
			return this.panel.matrix[result.toLowerCase()];
		}
	}
}
</script>
